import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3792131d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-center carousel rel" }
const _hoisted_2 = { class: "viewport box-shadow" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 0,
  class: "abs flex",
  style: {"width":"1200px","pointer-events":"none","flex-direction":"row-reverse"}
}
const _hoisted_8 = {
  class: "plugin flex-center-col",
  style: {"pointer-events":"auto"}
}
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { class: "bold mb_10" }
const _hoisted_11 = {
  class: "mb_30",
  style: {"font-size":"11px"}
}
const _hoisted_12 = {
  key: 0,
  href: "https://chromewebstore.google.com/detail/kaeru%E3%83%84%E3%83%BC%E3%83%ABthe-ckb/cbdgkflbadceflcbbogjkldbnjddnhbl",
  target: "_blank",
  class: "btn plugin-btn flex-center"
}
const _hoisted_13 = {
  key: 1,
  href: "https://chromewebstore.google.com/detail/the-ckb-easybuy/pdafojilkicifncfkalgilcpcnejebce",
  target: "_blank",
  class: "btn plugin-btn flex-center"
}

import { ref, reactive, onMounted } from 'vue'
import { getBannerList, incrementBanner as incrementBannerApi } from '@/apis/banner'
import { useRequest } from '@/util/useLoading'
import { isD2C, useRtfix, useSite2Station, isKO, isEN } from '@/store'
import { useStore } from 'vuex'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { bury } from '@/util/useBury'
import { t } from '@/plugins/i18n'
import MemberEventBox from './MemberEventBox.vue'
import { Site } from '@/common/const'

// 日本站 透明购/我的频道/市场购 banner
import jpCannelBanner from '@/assets/image/banner/jp-hannel-banner.png'
// 韩国站我的频道banner
import krChannelBanner from '@/assets/image/banner/kr-channel-banner.png'
// 韩国站透明够banner
import krPurchaseBanner from '@/assets/image/banner/kr-purchase-banner.png'
// 英国站我的频道banner
import ukChannelBanner from '@/assets/image/banner/uk-channel-banner.png'
// 英国站市场欧banner
import ukPurchaseBanner from '@/assets/image/banner/uk-purchase-banner.png'
// 英国站 市场购banner
import ukMarketBanner from '@/assets/image/banner/uk-market-banner.png'
import { TaEvent, taTrack } from '@/util/buryingPoint'

// 韩国市场购baneer

export default /*#__PURE__*/_defineComponent({
  props: {
  // banner类型 0-我的频道 1-透明购 2-市场购
  type: {
    type: String,
    default: ''
  },
  mallCategoryId: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props
const krMarketBanner = 'https://static-s.theckb.com/BusinessMarket/Client/market/kr-market-banner.png'
const upBurying = () => {
  if (!store.getters.isLogin) {

  }
}
const delay3 = ref(false)
const stationCode = useSite2Station()
setTimeout(() => {
  delay3.value = true
}, 3000)

const store = useStore()
onMounted(() => {
  getList()
})



const data: any = reactive({
  list: []
})

const csl = ref()

const index = ref(0)

const handlechange = (cur: number) => {
  index.value = cur
}

// 点击banner添加banner的数量
const incrementBanner = (id: number) => {
  incrementBannerApi(Number(id)).then(res => {
    console.log(res, 'res')
  })
}

// 获取banner列表
const [loading, getList] = useRequest(() => {
  if (data.list.length !== 0) {
    return new Promise<void>((resolve) => {
      resolve()
    })
  }
  const formData = {
    bannerType: props.type,
    systemSource: isD2C() ? '1' : '2',
    stationCode,
    mallCategoryId: props.mallCategoryId
  }
  return getBannerList(formData)
    .then((res: any) => {
      if (res.code === '0') {
        if (props.type !== '2') {
          if (res.data.length !== 0) {
            // 最多只展示50个
            data.list = res.data.slice(0, 50)
          } else {
            listAddDefaultImg()
          }
        } else {
          const arr = res.data
            .filter((item: any) => item.mallCategoryId === props.mallCategoryId)
            .slice(0, 50)

          if (arr.length !== 0) {
            data.list = arr
          } else {
            listAddDefaultImg()
          }
        }
      } else {
        listAddDefaultImg()
      }
    })
    .catch(() => {
      listAddDefaultImg()
    })
})

// 数据为空，添加默认图
const listAddDefaultImg = () => {
  const schannel: 0 | 1 | 2 = store.state.bussiness.schannel
  const defaultUrl = {
    // 我的频道
    0: {
      [Site.JA]: jpCannelBanner,
      [Site.KO]: krChannelBanner,
      [Site.EN]: ukChannelBanner
    },
    // 透明够
    2: {
      [Site.JA]: jpCannelBanner,
      [Site.KO]: krPurchaseBanner,
      [Site.EN]: ukPurchaseBanner
    },
    // 市场购
    1: {
      [Site.JA]: jpCannelBanner,
      [Site.KO]: krMarketBanner,
      [Site.EN]: ukMarketBanner
    }
  }[schannel][stationCode]

  // const imgurl = require("@/assets/image/banner/jp-hannel-banner.png")

  data.list.push({
    bannerImgUrl: defaultUrl,
    bannerJumpLink: '#',
    bannerId: '-1',
    bannerName: ''
  })
}

const Outwidth = ref(1920)
window.addEventListener('resize', (e) => {
  Outwidth.value = window.innerWidth
})

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(data).list.length !== 0)
        ? (_openBlock(), _createBlock(_component_el_carousel, {
            key: 0,
            ref: (_value, _refs) => {
              _refs['csl'] = _value
              csl.value = _value
            },
            height: Outwidth.value > 1200 ? '18.75vw' : '180px',
            interval: 3500,
            onChange: handlechange,
            "indicator-position": _unref(data).list.length === 1 ? 'none' : '',
            arrow: "never",
            class: _normalizeClass(_unref(data).list.length === 1 ? 'itemNone' : 'carouselContainer')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.bannerId
                }, [
                  (item.bannerJumpLink &&
            item.bannerJumpLink.indexOf('/article/') === -1
          )
                    ? (_openBlock(), _createBlock(_component_el_carousel_item, {
                        key: 0,
                        onClick: ($event: any) => (
            _unref(bury)(
              {
                2: 'ECBuy_Click_Banner',
                0: 'MyChannel_Click_Banner',
                1: 'MarketBuy_Click_Banner',
              }[_unref(store).state.bussiness.schannel as number] as string,
              item.bannerId
            ), incrementBanner(item.bannerId)
            )
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "wrap true",
                            href: item.bannerJumpLink,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              referrerPolicy: "no-referrer",
                              class: "wrap img",
                              src: item.bannerImgUrl,
                              alt: item.bannerName
                            }, null, 8, _hoisted_4)
                          ], 8, _hoisted_3)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(MemberEventBox, {
                        key: 1,
                        "no-token-fn": () => {
            _unref(taTrack)({
              event: _unref(TaEvent).PUPUP_WINDOW,
              value: {
                source: 'banner',
                position: 'login'
              }
            })
          },
                        subscript: false,
                        preventDefault: true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_carousel_item, {
                            onClick: ($event: any) => (
              _unref(bury)(
                {
                  2: 'ECBuy_Click_Banner',
                  0: 'MyChannel_Click_Banner',
                  1: 'MarketBuy_Click_Banner',
                }[_unref(store).state.bussiness.schannel as number] as string,
                item.bannerId
              ), incrementBanner(item.bannerId)
              )
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "wrap false",
                                href: item.bannerJumpLink,
                                target: "_blank"
                              }, [
                                _createElementVNode("img", {
                                  referrerPolicy: "no-referrer",
                                  class: "wrap img",
                                  src: item.bannerImgUrl,
                                  alt: item.bannerName
                                }, null, 8, _hoisted_6)
                              ], 8, _hoisted_5)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["no-token-fn"]))
                ], 64))
              }), 128)),
              _withDirectives(_createElementVNode("div", {
                class: "abs arrow aw-lf btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (csl.value.prev()))
              }, null, 512), [
                [_vShow, _unref(data).list.length !== 1]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "abs arrow aw-rt btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (csl.value.next()))
              }, null, 512), [
                [_vShow, _unref(data).list.length !== 1]
              ])
            ]),
            _: 1
          }, 8, ["height", "indicator-position", "class"]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(store).getters.isInstall && delay3.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(SvgIcon, {
              class: "mb_10",
              style: {"font-size":"65px"},
              name: "Googleicon"
            }),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)("chrome插件")), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("插件下载")), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)("插件简介")), 1),
            (_unref(isKO)())
              ? (_openBlock(), _createElementBlock("a", _hoisted_12, _toDisplayString(_unref(t)("立即安装")), 1))
              : _createCommentVNode("", true),
            (_unref(isEN)())
              ? (_openBlock(), _createElementBlock("a", _hoisted_13, _toDisplayString(_unref(t)("立即安装")), 1))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: _unref(useRtfix)('iframe', { params: { name: 'plugin' } }),
                  class: "btn plugin-btn flex-center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("立即安装")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
          ])
        ], 512)), [
          [_vShow, _unref(store).state.bussiness.schannel == '2']
        ])
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})